module.exports = __webpack_public_path__ + "img/icon-warning-generic-orange.164e1664.svg";